import { Map } from 'immutable';
import { actionTypes as CreateMaterialTypeDialogActionsType } from '../../../actions/Administration/MatSettingsPage/Dialogs/createMaterialTypeDialogActions.js';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
  dialogData: null,
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case CreateMaterialTypeDialogActionsType.CREATE_MATERIALTYPE_DIALOG_SHOW:
      state = state.set('itemToEdit', action.payload);
      return state.set('show',true);

    case CreateMaterialTypeDialogActionsType.CREATE_MATERIALTYPE_DIALOG_HIDE:
      return Map(defaultState);

    case CreateMaterialTypeDialogActionsType.CREATE_MATERIALTYPE_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set("loading", true);

    case CreateMaterialTypeDialogActionsType.CREATE_MATERIALTYPE_DIALOG_SUBMIT_FINISHED:
      return state.set("loading", false);

    case CreateMaterialTypeDialogActionsType.CREATE_MATERIALTYPE_DIALOG_FETCH_DATA_READY:
      return state.set("dialogData", action.payload);

    default:
      return state;
  }

}







